<template>
  <div style="margin-top: 2em;">
    <ul class="nav nav-tabs">
      <li v-for="(tab, index) in tabs" :key="index" :class="{ 'active': tab.isActive }">
        <i :class="tab.icon"></i>
        <a :href="tab.href" @click.prevent="selectTab(tab, tab.isValid)">{{ tab.name }}</a>
      </li>
    </ul>
    <div class="tab-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return { tabs: [] }
  },
  created: function () {
    this.tabs = this.$children
  },
  methods: {
    selectTab: function (selectedTab, isValid) { 
      if (isValid) {      
        this.tabs.forEach((tab) => {
          // tab.isActive = (tab.name == selectedTab.name); 
          // this.$parent.tabName = selectedTab.name;
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@import "../../../src/assets/css/variables";

a {
  padding-top: 0 !important;
}

i {
  color: $brand-color;
  font-style: normal;
  display: block;
}

.tab-content {
  display: block !important;
}

</style>







// WEBPACK FOOTER //
// src/components/shared/Tabs.vue